import { ShieldCheck } from "lucide-react";
import { useContent } from "../context/ContentContext";

export const GuaranteeBadge = ({ className = "" }) => {
  const { content } = useContent();
  const text = content?.settings?.guarantee;
  if (!text) return null;
  return (
    <span
      data-testid="guarantee-badge"
      className={`inline-flex items-center gap-2 border border-accent/40 bg-accent/5 px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] text-white/75 ${className}`}
    >
      <ShieldCheck size={14} className="text-accent flex-shrink-0" /> {text}
    </span>
  );
};
